import script from "./JigsawToolbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./JigsawToolbar.vue?vue&type=script&lang=ts&setup=true"

import "./JigsawToolbar.vue?vue&type=style&index=0&id=4b96a0c1&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b96a0c1"]])

export default __exports__